import { FormContainerComponent } from 'src/features/generalForms/builder/types/Container';
import { RPDF } from 'src/features/report/react-pdf';
import { FieldGroup } from 'src/features/report/records/components/FieldGroup';

export const Container: FormContainerComponent = ({ children, title }) => {
  return title ? (
    <FieldGroup title={title}>{children}</FieldGroup>
  ) : (
    <RPDF.View style={{ marginVertical: 8 }}>{children}</RPDF.View>
  );
};
